module.exports = __webpack_public_path__ + "img/faq.c154532f.svg";